export default "__VITE_ASSET__923c5394__"